export default {
    name: 'OfferSlots',
    props: { show: Boolean, width: String, height: String, isMobile: Boolean }
};
